import React, { Fragment, useState } from 'react';
import styles from './styles.module.scss';
import FormLabel from '../FormLabel';

import { Toaster, Icons, Button, InputBox } from '@densityco/ui';

type BasicAuthLoginProps = {
  headerAppName: React.ReactNode;
  buttonAppName?: React.ReactNode;
  loginHost: string;
  onLoginComplete: (token: string) => void;
};

const BasicAuthLogin: React.FunctionComponent<BasicAuthLoginProps> = ({
  headerAppName,
  buttonAppName = null,
  loginHost,
  onLoginComplete,
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Otherwise, the user isn't logged in so render the login page.
  async function login() {
    const response = await fetch(`${loginHost}/v2/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    // If the token is invalid, redirect back to the login page.
    if (!response.ok) {
      Toaster.showToast({ type: 'error', text: 'Invalid email or password!' });
      return;
    }
    setEmail('');
    setPassword('');

    const token = await response.json();
    onLoginComplete(token);
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <Icons.DensityMark width={24} height={24} />
          <span className={styles.text}>{headerAppName}</span>
        </div>

        <div className={styles.body}>
          <FormLabel
            label="Your Email"
            htmlFor="email"
            input={
              <InputBox
                id="email"
                type="text"
                value={email}
                width="100%"
                placeholder="ex: bonnie.raitt@density.io"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
              />
            }
          />

          <FormLabel
            label="Your Password"
            htmlFor="password"
            input={
              <InputBox
                id="password"
                type="password"
                width="100%"
                placeholder="Password"
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                onKeyPress={(e: any) => {
                  if (e.key === 'Enter') {
                    login();
                  }
                }}
              />
            }
          />
        </div>

        <Button variant="filled" width="100%" onClick={() => login()}>
          Log in{buttonAppName ? <Fragment> to {buttonAppName}</Fragment> : null}
        </Button>
      </div>
    </div>
  );
};

BasicAuthLogin.displayName = 'BasicAuthLogin';
export default BasicAuthLogin;
